import axios from 'axios';
import { datajs, datajsAll, disableElements, enableElements } from '../shared/utils';

export default class ContactForm {
	static init() {
		const contactForm = document.getElementById('contact-form');
		const closeContactFormModalButtons = datajsAll('close-contact-form-modal');
		let isTransitioning = false;

		if (!contactForm) {
			return;
		}

		const hideContactFormModal = () => {
			if (isTransitioning) {
				return false;
			}

			isTransitioning = true;

			// Remove Transition CSS class 2
			parent.document.body.classList.remove('has-contact-form');

			// Remove Transition CSS class 1
			setTimeout(function () {
				parent.document.body.classList.remove('has-activated-contact-form');

				isTransitioning = false;
			}, 650);

			return false;
		};

		contactForm?.addEventListener('submit', (e) => {
			e.preventDefault();

			const submitBtn = datajs('contact-form-submit-btn');
			const stateIndicator = datajs('btn-state-indicator', submitBtn);
			const validationMessage = datajs('validation-message');
			const validationMessageContent = datajs('validation-message-content');

			const formData = new FormData(contactForm);
			const formInputs = contactForm.querySelectorAll('input, textarea, button');

			const appGlobals = window.AppGlobals;
			const adminUrl = appGlobals.adminUrl;
			const title = appGlobals.contactFormSuccessTitle || false;
			const message = appGlobals.contactFormSuccessMessage || false;
			const errorMessage = appGlobals.contactFormErrorMessage || false;

			validationMessage.classList.add('d-none');

			const disableForm = () => {
				disableElements(formInputs);
				stateIndicator?.classList.remove('d-none');
			};

			const enableForm = () => {
				enableElements(formInputs);
				stateIndicator?.classList.add('d-none');
			};

			const onSuccess = () => {
				contactForm.classList.add('d-none');

				if (title) {
					validationMessageContent.innerHTML = `<h3 class="u-textUnderline display-6">${title}</h3>`;
				}

				if (message) {
					validationMessageContent.innerHTML += `<p class="lead">${message}</p>`;
				}

				validationMessage.classList.add('success');
				validationMessage.classList.remove('d-none');

				// Check if we are on the right page by checking the body class
				const bodyClassList = parent.document.body.classList;
				if (!bodyClassList.contains('postid-36')) {
						return;
				}

    		// Determine if the form is in a popup or on the page
    		const formLocation = parent.document.body.classList.contains('has-contact-form') ? 'popup' : 'onPage';

    		// Push to dataLayer
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
						'event': 'form_submitted_byggkonstruktion',
						'formLocation': formLocation
				});
			};

			const onError = () => {
				contactForm.classList.add('d-none');
				validationMessageContent.innerHTML = `<p>${errorMessage}</p>`;
				validationMessage.classList.add('error', 'mt-2');
				validationMessage.classList.remove('d-none');

				setTimeout(resetForm, 10000);
			};

			const resetForm = () => {
				contactForm.reset();
				contactForm.classList.remove('d-none');
				validationMessage.classList.add('d-none');
				enableForm();
			};

			const sendToDynamics = typeof window?.MsCrmMkt?.MsCrmFormLoader?.sendFormCaptureToCrm === 'function';

			disableForm();

			if (sendToDynamics) {
				window.MsCrmMkt.MsCrmFormLoader.sendFormCaptureToCrm(contactForm)
					.then((response) => {
						const { SubmissionStatus } = JSON.parse(response);

						if (SubmissionStatus === 'Success') {
							onSuccess();
						} else {
							onError();
						}
					})
					.catch((error) => {
						console.error(error);
						onError();
					});
			} else {
				formData.append('action', 'send_contact_form');

				// Post form
				axios
					.post(`${adminUrl}admin-ajax.php`, formData)
					.then((response) => {
						const success = response?.data?.success || false;

						if (success) {
							onSuccess();
						} else {
							onError();
						}
					})
					.catch((error) => {
						console.error(error);
						onError();
					});
			}
		});

		// Hide off canvas overlay if site header search overlay is activated
		if (closeContactFormModalButtons) {
			closeContactFormModalButtons.forEach((button) => {
				button.addEventListener('click', hideContactFormModal);
			});
		}
	}
}
